import Papa from 'papaparse';
import papaparseSource from 'papaparse/papaparse.min?raw';

/**
 * PapaParse never listens for errors on its worker, so an uncaught exception there would
 * leave the parse waiting forever. Reporting it with the message shape the worker uses
 * for its own failures routes it to the caller's error callback instead.
 */
const WORKER_PRELUDE = `self.IS_PAPA_WORKER = true;
var papaWorkerId;
self.addEventListener('message', function (event) {
    if (papaWorkerId === undefined && event.data) {
        papaWorkerId = event.data.workerId;
    }
});
self.addEventListener('error', function (event) {
    self.postMessage({ workerId: papaWorkerId, error: { message: event.message }, finished: false });
    self.close();
});
`;

/**
 * PapaParse builds its worker script by stringifying its own module factory, but our
 * production minifier rewrites that factory for module (strict-mode) scoping and drops
 * its 'use strict' directive, so the stringified copy breaks once it runs as a classic
 * worker script. Building the worker from the unmodified package source avoids that.
 */
export function preparePapaParseWorker(): void {
    if (!Papa.WORKERS_SUPPORTED || undefined !== Papa.BLOB_URL) {
        return;
    }

    Papa.BLOB_URL = URL.createObjectURL(new Blob([WORKER_PRELUDE, papaparseSource], { type: 'text/javascript' }));
}
